/* AgriEID redesign v192 — behaviour for the ae-* sections.
   No dependencies. Works with the theme editor (re-inits on section load). */
(function () {
  'use strict';

  /* ---------------- helpers ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    // A store's money format can carry markup (<span class=money>$1,995</span>, used by currency converters).
    // These prices are written as text, so keep only the text of the format.
    format = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    var value = (Number(cents) || 0) / 100;
    function withDelim(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelim(value, 0);
        case 'amount_with_comma_separator': return withDelim(value, 2).replace('.', ',');
        default: return withDelim(value, 2);
      }
    });
    return out.replace(/\.00(?!\d)/, '');   // drop trailing zeros like the theme's money_without_trailing_zeros
  }

  /* ---------------- FAQ accordion (single open) ---------------- */
  function initFaq(root) {
    $$('.ae-faq', root).forEach(function (faq) {
      if (faq.dataset.aeReady) return;
      faq.dataset.aeReady = '1';
      faq.addEventListener('click', function (e) {
        var btn = e.target.closest('.ae-faq__q');
        if (!btn || !faq.contains(btn)) return;
        var item = btn.closest('.ae-faq__item');
        var wasOpen = item.classList.contains('is-open');
        if (faq.hasAttribute('data-single')) {
          $$('.ae-faq__item.is-open', faq).forEach(function (i) {
            i.classList.remove('is-open');
            var b = $('.ae-faq__q', i); if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (!wasOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* ---------------- video poster → inline player ---------------- */
  function initVideos(root) {
    $$('.ae-video', root).forEach(function (box) {
      if (box.dataset.aeReady) return;
      box.dataset.aeReady = '1';
      box.addEventListener('click', function (e) {
        if (box.querySelector('video,iframe')) return;   // the player is in place: this click belongs to it
        var vimeo = box.getAttribute('data-vimeo');
        var mp4 = box.getAttribute('data-mp4');
        if (!vimeo && !mp4) return;              // plain link
        e.preventDefault();
        var el;
        if (vimeo) {
          el = document.createElement('iframe');
          el.src = 'https://player.vimeo.com/video/' + encodeURIComponent(vimeo) + '?autoplay=1&title=0&byline=0&portrait=0';
          el.allow = 'autoplay; fullscreen; picture-in-picture';
          el.setAttribute('allowfullscreen', '');
          el.title = 'Video';
        } else {
          el = document.createElement('video');
          el.src = mp4; el.controls = true; el.autoplay = true; el.playsInline = true;
          el.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;background:#000';
        }
        box.innerHTML = '';
        box.appendChild(el);
        box.removeAttribute('href');
      });
    });
  }

  /* ---------------- buy box ---------------- */
  var AE = window.AE = window.AE || {};

  function BuyBox(root) {
    this.root = root;
    var data = $('script[data-ae-variants]', root);
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.money = root.getAttribute('data-money') || '${{amount}}';
    this.form = $('form[data-ae-form]', root);
    this.idInput = this.form ? $('input[name="id"]', this.form) : null;
    this.qtyInput = this.form ? $('input[name="quantity"]', this.form) : null;
    this.atc = $('.ae-atc', root);
    this.atcLabel = $('[data-ae-atc-label]', root);
    this.atcText = this.atcLabel ? this.atcLabel.textContent : 'Add to cart';
    this.captionMode = root.getAttribute('data-caption') || 'product';
    this.productTitle = root.getAttribute('data-title') || '';
    // every picture of the gallery, in page order: {b: group number, src, alt, p: 1 for one of the product's own photos}
    this.slides = [];
    var sj = $('script[data-ae-slides]', root);
    if (sj) { try { this.slides = JSON.parse(sj.textContent) || []; } catch (e) { this.slides = []; } }
    this.slideIndex = -1;
    this.leading = {};   // group numbers set to show first for the selected option
    this.qty = 1;
    var current = this.idInput ? String(this.idInput.value) : '';
    this.current = this.find(current) || this.variants[0];
    this.bind();
    this.applyVariant(this.current, true);
    if (window.location.hash === '#bundle') this.applyVariant(this.bundle() || this.current);
  }

  // the reader package option; when there are several, the one built on the selected scales option
  BuyBox.prototype.bundle = function () {
    var cur = this.current, base = cur ? (cur.bundle ? cur.base : cur.id) : null, first = null;
    for (var i = 0; i < this.variants.length; i++) {
      var b = this.variants[i];
      if (!b.bundle) continue;
      if (String(b.base) === String(base)) return b;
      if (!first) first = b;
    }
    return first;
  };

  BuyBox.prototype.find = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (String(this.variants[i].id) === String(id)) return this.variants[i];
    return null;
  };

  BuyBox.prototype.bind = function () {
    var self = this;
    $$('.ae-vopt[data-variant-id]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var v = self.find(btn.getAttribute('data-variant-id'));
        if (v) self.applyVariant(v);
      });
    });
    $$('.ae-thumb', this.root).forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); self.showThumb(t); });
    });
    $$('[data-ae-prev],[data-ae-next]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); self.step(b.hasAttribute('data-ae-next') ? 1 : -1); });
    });
    var hero = $('[data-ae-hero]', this.root), x0 = null;
    if (hero && hero.parentNode) {  // swipe the main image on a phone
      hero.parentNode.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.parentNode.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) self.step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    $$('[data-ae-qty]', this.root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        self.setQty(self.qty + Number(b.getAttribute('data-ae-qty')));
      });
    });
    if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); });
  };

  BuyBox.prototype.setQty = function (n) {
    this.qty = Math.max(1, Math.min(999, n || 1));
    var q = $('[data-ae-qty-val]', this.root);
    if (q) q.textContent = this.qty;
    if (this.qtyInput) this.qtyInput.value = this.qty;
    this.renderTotal();
  };

  BuyBox.prototype.renderTotal = function () {
    var t = $('[data-ae-total]', this.root);
    if (t && this.current) t.textContent = formatMoney(this.current.price * this.qty, this.money);
  };

  BuyBox.prototype.matches = function (thumb, v, attr) {
    var list = (thumb.getAttribute(attr || 'data-variants') || '').toLowerCase().split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!list.length) return true;
    var title = (v.title + ' ' + (v.name || '')).toLowerCase();
    for (var i = 0; i < list.length; i++) if (title.indexOf(list[i]) !== -1) return true;
    return false;
  };

  // a group set to show first for this option ("Show first for options containing"), e.g. the load bar photos for Load Bars Only
  BuyBox.prototype.leads = function (thumb, v) {
    return !!(thumb.getAttribute('data-first') || '').trim() && this.matches(thumb, v, 'data-first');
  };

  // the pictures of the groups shown for the selected option, as positions in this.slides; leading groups come first
  BuyBox.prototype.visibleSlides = function () {
    var open = {}, front = [], out = [];
    $$('.ae-thumb', this.root).forEach(function (t) { if (!t.hidden) open[t.getAttribute('data-bucket')] = true; });
    for (var i = 0; i < this.slides.length; i++) if (open[this.slides[i].b]) (this.leading[this.slides[i].b] ? front : out).push(i);
    return front.concat(out);
  };

  // a thumbnail is a group: show its first picture
  BuyBox.prototype.showThumb = function (thumb) {
    if (!thumb) return;
    var b = thumb.getAttribute('data-bucket');
    for (var i = 0; i < this.slides.length; i++) if (String(this.slides[i].b) === b) { this.showSlide(i); return; }
  };

  BuyBox.prototype.step = function (dir) {
    var vis = this.visibleSlides();
    if (!vis.length) return;
    var at = vis.indexOf(this.slideIndex);
    if (at < 0) at = dir > 0 ? -1 : 0;
    this.showSlide(vis[(at + dir + vis.length) % vis.length]);
  };

  BuyBox.prototype.showSlide = function (i) {
    var slide = this.slides[i];
    if (!slide) return;
    this.slideIndex = i;
    var thumb = null, total = 0, pos = 0;
    $$('.ae-thumb', this.root).forEach(function (t) {
      var on = t.getAttribute('data-bucket') === String(slide.b);
      t.setAttribute('aria-current', on ? 'true' : 'false');
      if (on) thumb = t;
    });
    for (var k = 0; k < this.slides.length; k++) if (this.slides[k].b === slide.b) { total++; if (k === i) pos = total; }
    var label = thumb ? (thumb.getAttribute('data-label') || '') : '';
    var opt = this.captionMode === 'variant' && this.current ? (this.current.label || this.current.name) : '';
    var hero = $('[data-ae-hero]', this.root);
    if (hero) {
      if (slide.src && hero.getAttribute('src') !== slide.src) {
        hero.setAttribute('src', slide.src);
        hero.removeAttribute('srcset');
      }
      hero.setAttribute('alt', slide.p ? (slide.alt || [this.productTitle, label].filter(Boolean).join(' - '))
        : [this.productTitle, opt, label].filter(Boolean).join(' - '));
      // one of the product's own photos can show another option's hardware, so the option tag only goes on a group's own image
      var tag = $('[data-ae-vlabel]', hero.parentNode);
      if (tag) tag.hidden = !!slide.p;
    }
    var count = $('[data-ae-count]', this.root);
    if (count) { count.hidden = total < 2; count.textContent = pos + ' / ' + total; }
    var cap = $('[data-ae-caption]', this.root);
    if (cap) {
      var suffix = this.captionMode === 'variant' ? opt : this.productTitle;
      cap.textContent = [label, slide.p ? pos + ' of ' + total : suffix].filter(Boolean).join(' \u00b7 ');
    }
  };

  BuyBox.prototype.applyVariant = function (v, initial) {
    if (!v) return;
    var self = this;
    this.current = v;
    if (this.idInput) this.idInput.value = v.id;
    $$('.ae-vopt[data-variant-id]', this.root).forEach(function (b) {
      b.setAttribute('aria-checked', String(b.getAttribute('data-variant-id')) === String(v.id) ? 'true' : 'false');
    });
    // several package options: show the one built on the selected scales option
    var base = v.bundle ? v.base : v.id;
    $$('[data-ae-bundle-base]', this.root).forEach(function (el) {
      el.hidden = String(el.getAttribute('data-ae-bundle-base')) !== String(base);
    });
    // price block
    var price = formatMoney(v.price, this.money);
    var was = v.compare_at_price && v.compare_at_price > v.price ? formatMoney(v.compare_at_price, this.money) : '';
    $$('[data-ae-price]', this.root).forEach(function (el) { el.textContent = price; });
    $$('[data-ae-was]', this.root).forEach(function (el) { el.textContent = was; el.hidden = !was; });
    $$('[data-ae-save]', this.root).forEach(function (el) {
      var save = was ? formatMoney(v.compare_at_price - v.price, self.money) : '';
      el.textContent = save ? 'Save ' + save + (v.save_suffix || '') : ''; el.hidden = !save;
    });
    $$('[data-ae-pkg]', this.root).forEach(function (el) { el.textContent = 'USD · ' + (v.name || v.title) + ' package'; });
    $$('[data-ae-vlabel]', this.root).forEach(function (el) { el.textContent = v.label || v.name || v.title; });
    // gallery: show this variant's pictures plus the shared ones; a group set to lead for this option moves to the front
    var first = null, lead = null;
    this.leading = {};
    $$('.ae-thumb', this.root).forEach(function (t) {
      var show = self.matches(t, v), front = show && self.leads(t, v);
      t.hidden = !show;
      t.style.order = front ? '-1' : '';
      if (front) { self.leading[t.getAttribute('data-bucket')] = true; if (!lead) lead = t; }
      if (show && !first) first = t;
    });
    var cur = $('.ae-thumb[aria-current="true"]:not([hidden])', this.root);
    this.showThumb(initial && cur ? cur : (lead || first));
    var many = this.visibleSlides().length > 1;
    $$('[data-ae-prev],[data-ae-next]', this.root).forEach(function (b) { b.hidden = !many; });
    // stock / button
    if (this.atc) {
      if (v.available) { this.atc.removeAttribute('disabled'); if (this.atcLabel) this.atcLabel.textContent = v.atc || this.atcText; }
      else { this.atc.setAttribute('disabled', 'disabled'); if (this.atcLabel) this.atcLabel.textContent = 'Sold out'; }
    }
    this.renderTotal();
    if (!initial) {
      try {
        var url = new URL(window.location.href);
        if (v.bundle) url.searchParams.delete('variant'); else url.searchParams.set('variant', v.id);
        if (!v.bundle && url.hash === '#bundle') url.hash = '';
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignore */ }
    }
    AE.variant = v;
    document.dispatchEvent(new CustomEvent('ae:variant', { detail: { variant: v, price: price, was: was, title: this.productTitle } }));
  };

  BuyBox.prototype.submit = function (e) {
    var self = this;
    if (!window.fetch || !window.FormData) return;     // plain form post → /cart
    e.preventDefault();
    if (!this.current || !this.current.available) return;
    var err = $('.ae-buy__error', this.root);
    if (err) { err.hidden = true; err.textContent = ''; }
    if (this.atc) this.atc.classList.add('is-loading');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(this.current.id), quantity: this.qty }] })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        if (self.atcLabel) self.atcLabel.textContent = 'Added to cart ✓';
        $$('.mega-nav__cart-count').forEach(function (c) { c.textContent = String(Number(c.textContent || 0) + self.qty); });
        window.location.href = root + 'cart';   // straight to the cart (v265: no 0.7 second pause)
      })
      .catch(function (ex) {
        if (err) { err.textContent = ex.message; err.hidden = false; }
        if (self.atc) self.atc.classList.remove('is-loading');
      });
  };

  AE.selectVariant = function (id, scroll) {
    var box = AE.buyBox;
    if (!box) return;
    var v = box.find(id);
    if (v) box.applyVariant(v);
    if (scroll) {
      var target = document.getElementById('buy') || box.root;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  AE.selectBundle = function (scroll) {
    var box = AE.buyBox;
    var b = box ? box.bundle() : null;
    if (!b) return false;
    box.applyVariant(b);
    if (scroll) (document.getElementById('buy') || box.root).scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  };

  // any link to #bundle on the product's own page selects the package instead of jumping
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href$="#bundle"]') : null;
    if (!a || a.pathname !== window.location.pathname) return;
    if (AE.selectBundle(true)) e.preventDefault();
  });

  AE.addToCart = function () {
    var box = AE.buyBox;
    if (!box || !box.form) return false;
    if (box.form.requestSubmit) box.form.requestSubmit(); else box.form.submit();
    return true;
  };

  function initBuyBox(root) {
    $$('[data-ae-buy]', root).forEach(function (el) {
      if (el.dataset.aeReady) return;
      el.dataset.aeReady = '1';
      AE.buyBox = new BuyBox(el);
    });
  }

  /* ---------------- "Select this system" cards ---------------- */
  function initSystemCards(root) {
    $$('[data-ae-systems]', root).forEach(function (wrap) {
      if (wrap.dataset.aeReady) return;
      wrap.dataset.aeReady = '1';
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-ae-select]');
        if (!btn) return;
        e.preventDefault();
        AE.selectVariant(btn.getAttribute('data-ae-select'), true);
      });
    });
  }

  function syncVariantListeners(v, price) {
    // system cards
    $$('[data-ae-systems] .ae-sys').forEach(function (card) {
      var on = String(card.getAttribute('data-variant-id')) === String(v.bundle && v.base ? v.base : v.id);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
      var b = $('.ae-sys__btn', card);
      if (b) b.textContent = on ? (b.getAttribute('data-on') || 'Selected') : (b.getAttribute('data-off') || 'Select this system');
    });
    // bottom CTA bars
    $$('[data-ae-cta]').forEach(function (bar) {
      var t = $('[data-ae-cta-title]', bar);
      if (t) {
        var tpl = t.getAttribute('data-template') || '{name} package · {price}';
        t.textContent = tpl.replace('{name}', v.name || v.title).replace('{price}', price).replace('{title}', bar.getAttribute('data-title') || '');
      }
      var sub = $('[data-ae-cta-sub]', bar);
      if (sub && sub.getAttribute('data-variant') === 'true') sub.textContent = v.name || v.title;
    });
    // "In the box" text follows the selected option
    $$("[data-ae-box]").forEach(function (el) { if (v.box) el.textContent = v.box; });
  }

  document.addEventListener('ae:variant', function (e) { syncVariantListeners(e.detail.variant, e.detail.price); });

  function initCta(root) {
    $$('[data-ae-cta] [data-ae-cta-btn]', root).forEach(function (btn) {
      if (btn.dataset.aeReady) return;
      btn.dataset.aeReady = '1';
      btn.addEventListener('click', function (e) {
        if (AE.buyBox && AE.buyBox.current && AE.buyBox.current.available) {
          e.preventDefault();
          AE.addToCart();
        }
      });
    });
  }

  /* ---------------- motion: reveal on scroll, count-up numbers, step walk, image slider ---------------- */
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canWatch = 'IntersectionObserver' in window;

  // calls enter() / leave() as el scrolls in and out of view
  function watch(el, enter, leave, amount) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) enter(io); else if (leave) leave();
      });
    }, { threshold: amount || 0.15 });
    io.observe(el);
  }

  // hides el until it is scrolled to; left alone when it is already on screen
  function arm(el) {
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) return false;
    el.classList.add('is-armed');
    return true;
  }

  // "$5K-$12K" -> shows "$0K-$0K" and returns a function that counts every number up to its value
  function counter(el) {
    var text = el.textContent;
    var parts = text.split(/(\d[\d,]*(?:\.\d+)?)/);      // odd indexes are the numbers
    if (parts.length < 2) return null;
    function draw(k) {
      el.textContent = parts.map(function (s, i) {
        if (i % 2 === 0) return s;
        var dec = (s.split('.')[1] || '').length;
        var n = (Number(s.replace(/,/g, '')) * k).toFixed(dec);
        return s.indexOf(',') === -1 ? n : n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }).join('');
    }
    el.style.minHeight = el.offsetHeight + 'px';         // shorter numbers must not re-wrap a heading mid-count
    draw(0);
    return function () {
      var t0 = null;
      function frame(now) {
        if (t0 === null) t0 = now;
        var k = Math.min(1, (now - t0) / 1400);
        if (k < 1) { draw(1 - Math.pow(1 - k, 3)); window.requestAnimationFrame(frame); }
        else { el.textContent = text; el.style.minHeight = ''; }
      }
      window.requestAnimationFrame(frame);
    };
  }

  function initReveal(root) {
    if (still || !canWatch) return;
    $$('[data-ae-rise],[data-ae-stats]', root).forEach(function (el) {
      if (el.dataset.aeReady) return;
      el.dataset.aeReady = '1';
      if (!arm(el)) return;
      var wait = (parseFloat(el.style.getPropertyValue('--i')) || 0) * 120;
      var counts = $$('[data-ae-count]', el).map(counter);
      watch(el, function (io) {
        io.disconnect();
        el.classList.remove('is-armed');
        counts.forEach(function (run, i) { if (run) setTimeout(run, wait + 150 + i * 140); });
        setTimeout(function () { el.style.setProperty('--i', '0'); }, wait + 800);   // hover states should not wait
      });
    });
  }

  function initSteps(root) {
    $$('[data-ae-steps]', root).forEach(function (strip) {
      if (strip.dataset.aeReady) return;
      strip.dataset.aeReady = '1';
      var steps = $$('.ae-step', strip);
      if (!steps.length || still || !canWatch) return;
      var ms = 2600, at = -1, timer = null, visible = false, held = false;
      strip.style.setProperty('--ae-ms', ms + 'ms');
      function show(i) {                        // steps before i are done, i is filling; -1 clears the strip
        at = i;
        steps.forEach(function (st, n) {
          st.classList.toggle('is-done', n < i);
          st.classList.toggle('is-active', n === i);
        });
      }
      function later(fn, wait) { clearTimeout(timer); timer = setTimeout(fn, wait); }
      function advance() {
        if (!visible || held || document.hidden) return;
        if (at >= steps.length) { show(-1); later(advance, 600); }     // let the line fade before starting again
        else { show(at + 1); later(advance, at >= steps.length ? 1200 : ms); }
      }
      var armed = arm(strip);
      watch(strip, function () {
        visible = true;
        strip.classList.remove('is-armed');
        later(advance, armed ? 900 : 400);
        armed = false;
      }, function () { visible = false; clearTimeout(timer); }, 0.3);
      steps.forEach(function (st, n) {
        st.addEventListener('mouseenter', function () { held = true; clearTimeout(timer); show(n); });
      });
      strip.addEventListener('mouseleave', function () { held = false; later(advance, 1200); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) later(advance, 400); });
    });
  }

  function initSliders(root) {
    $$('[data-ae-slider]', root).forEach(function (el) {
      if (el.dataset.aeReady) return;
      el.dataset.aeReady = '1';
      var track = $('.ae-slider__track', el), slides = $$('.ae-slide', el), dots = $$('.ae-slider__dot', el);
      if (!track || slides.length < 2) return;
      var ms = (Number(el.getAttribute('data-seconds')) || 4) * 1000;
      var at = 0, timer = null, settle = null, visible = false, held = false, eager = false;
      function mark(i) {
        at = i;
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      function go(i, instant) {
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: instant || still ? 'auto' : 'smooth' });
        mark(i);
      }
      function next() {
        if (at < slides.length - 1) return go(at + 1);
        track.classList.add('is-wrapping');          // back to the first: fade rather than rewind through every image
        setTimeout(function () { go(0, true); track.classList.remove('is-wrapping'); }, 260);
      }
      function play() {
        clearInterval(timer); timer = null;
        var on = visible && !held && !still && !document.hidden;
        el.classList.toggle('is-playing', on);
        if (on) timer = setInterval(next, ms);
      }
      el.aeGo = function (i) { go(i, true); play(); };
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
      track.addEventListener('scroll', function () {   // follow a swipe once it comes to rest
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = Math.round(track.scrollLeft / (slides[1].offsetLeft - slides[0].offsetLeft));
          if (i !== at && i >= 0 && i < slides.length) { mark(i); play(); }
        }, 140);
      }, { passive: true });
      el.addEventListener('mouseenter', function () { held = true; play(); });
      el.addEventListener('mouseleave', function () { held = false; play(); });
      el.addEventListener('focusin', function () { held = true; play(); });
      el.addEventListener('focusout', function () { held = false; play(); });
      el.addEventListener('touchstart', function () { held = true; play(); }, { passive: true });
      el.addEventListener('touchend', function () { setTimeout(function () { held = false; play(); }, 2500); }, { passive: true });
      document.addEventListener('visibilitychange', play);
      if (!canWatch) return;
      watch(el, function () {
        if (!eager) { eager = true; $$('img', el).forEach(function (img) { img.loading = 'eager'; }); }
        visible = true; play();
      }, function () { visible = false; play(); }, 0.4);
    });
  }

  // theme editor: bring the slide being edited into view
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('.ae-slide') : null;
    var slider = slide ? slide.closest('[data-ae-slider]') : null;
    if (slider && slider.aeGo) slider.aeGo($$('.ae-slide', slider).indexOf(slide));
  });

  function init(root) {
    initReveal(root);
    initSteps(root);
    initSliders(root);
    initFaq(root);
    initVideos(root);
    initBuyBox(root);
    initSystemCards(root);
    initCta(root);
    if (AE.buyBox && AE.buyBox.current) syncVariantListeners(AE.buyBox.current, formatMoney(AE.buyBox.current.price, AE.buyBox.money));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
